<mat-card>
  <mat-card-content>
    <div class="description">
      <mat-icon> info_outline </mat-icon>&nbsp;
      <span translate="parameters/track-link-labels/usage-description"></span>
    </div>

    <app-search-bar
      [primaryButtonAction]="primaryButtonAction"
      primaryButtonKey="parameters/track-link-labels/new-track-link-label"></app-search-bar>

    <app-table [config]="config" [filters]="filters"></app-table>
  </mat-card-content>
</mat-card>

<ng-template #templateDependenciesTemplateRef let-templates="templates">
  <li *ngFor="let template of templates">
    <a [href]="template.url" rel="noopener noreferrer" target="_blank">{{ template.template_name }}</a>
  </li>
</ng-template>
